if (!customElements.get('collection-filters')) {
  customElements.define('collection-filters', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.media = window.matchMedia('(max-width: 798px)');
      this.panel = this.querySelector('.collection-filters__panel');
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('.collection-filters__trigger');
      this.form = this.querySelector('form');
      this.sort = this.querySelector('select');
      this.groups = [...this.querySelectorAll('.faceted-filter-group')];
      this.updateStickyOffset = () => {
        const header = document.querySelector('.header-group');
        const stickyNav = document.querySelector('.sticky_nav--stick');
        const headerBottom = header ? header.getBoundingClientRect().bottom : 0;
        const navBottom = stickyNav ? stickyNav.getBoundingClientRect().bottom : 0;
        this.style.setProperty('--collection-filters-header-height', `${Math.max(0, headerBottom, navBottom)}px`);
      };
      this.updateStickyOffset();
      window.addEventListener('scroll', this.updateStickyOffset, { passive: true });
      window.addEventListener('resize', this.updateStickyOffset);
      this.groups.forEach(group => { group.open = false; });
      this.trigger.hidden = false;
      this.updateLayout = () => {
        if (this.dialog.open) this.dialog.close();
        this.querySelector(this.media.matches ? '.collection-filters__body' : '.collection-filters__desktop').append(this.panel);
      };
      this.media.addEventListener('change', this.updateLayout);
      this.updateLayout();
      this.trigger.addEventListener('click', () => {
        this.previousOverflow = document.body.style.overflow;
        this.dialog.showModal();
        document.body.style.overflow = 'hidden';
      });
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow || '';
        this.trigger.focus();
      });
      this.querySelector('.collection-filters__close').addEventListener('click', () => this.dialog.close());
      if (!this.form) this.querySelector('.collection-filters__footer button').addEventListener('click', () => this.submitFilters());
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      this.addEventListener('change', event => {
        if (event.target.matches('.collection-filters__sort-options input')) this.sort.value = event.target.value;
        if (event.target === this.sort || event.target.matches('.collection-filters__sort-options input')) {
          this.querySelectorAll('.collection-filters__sort-options input').forEach(input => { input.checked = input.value === this.sort.value; });
        }
        if (event.target === this.sort || event.target.matches('.collection-filters__sort-options input')) {
          const input = this.form && this.form.elements.namedItem('sort_by');
          if (input) input.value = this.sort.value;
        }
        if (!this.media.matches && event.target.type !== 'number') this.submitFilters();
      });
      if (this.form) this.form.addEventListener('submit', event => {
        event.preventDefault();
        this.submitFilters();
      });
      this.groups.forEach(group => group.addEventListener('toggle', () => {
        if (this.media.matches || !group.open) return;
        this.groups.forEach(other => { if (other !== group) other.open = false; });
      }));
      this.outsideClick = event => {
        if (!this.media.matches && !this.contains(event.target)) this.groups.forEach(group => { group.open = false; });
      };
      document.addEventListener('click', this.outsideClick);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !this.media.matches) {
          const group = event.target.closest('details');
          if (group) { group.open = false; group.querySelector('summary').focus(); }
        }
      });
    }
    submitFilters() {
      const url = new URL(window.location.href);
      [...url.searchParams.keys()].forEach(key => {
        if (key.startsWith('filter.') || key === 'page' || key === 'sort_by') url.searchParams.delete(key);
      });
      if (this.form) {
        const formData = new FormData(this.form);
        new Set(formData.keys()).forEach(key => url.searchParams.delete(key));
        formData.forEach((value, key) => {
          if (value !== '') url.searchParams.append(key, value);
        });
      }
      if (this.sort) url.searchParams.set('sort_by', this.sort.value);
      window.location.assign(url.toString());
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.updateStickyOffset);
      window.removeEventListener('resize', this.updateStickyOffset);
      this.media.removeEventListener('change', this.updateLayout);
      document.removeEventListener('click', this.outsideClick);
      if (this.dialog.open) document.body.style.overflow = this.previousOverflow || '';
      this.initialized = false;
    }
  });
}
